import { render, staticRenderFns } from "./declear.vue?vue&type=template&id=080a9616&scoped=true"
import script from "./declear.vue?vue&type=script&lang=js"
export * from "./declear.vue?vue&type=script&lang=js"
import style0 from "./declear.vue?vue&type=style&index=0&id=080a9616&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a9616",
  null
  
)

export default component.exports